import { palette } from '@plataforma/components';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 184px;
  width: 864px;
  display: grid;
  grid-template-columns:
    ${({ columnsWidths }) =>
      `${columnsWidths[0]} ${columnsWidths[1]} ${columnsWidths[2]}`}
  border-radius: 4px;
  ${({ backgroundColor }) => `background-color: ${backgroundColor};`}

  & > div:nth-child(2) {
    display: flex;
    flex-flow: column;
    align-self: center;
  }
`;

export const Title = styled.h2`
  font-weight: 600;
  ${({ lineHeight, fontSize, color }) => `
    font-size: ${fontSize};
    line-height: ${lineHeight};
    color: ${color};
  `}
  margin: 0px;
  margin-bottom: 8px;
`;

export const Text = styled.p`
  font-weight: 400;
  ${({ lineHeight, fontSize, color }) => `
  font-size: ${fontSize};
  line-height: ${lineHeight};
  color: ${color};
`}
  margin: 0px;
  margin-bottom: 8px;
`;

export const Button = styled.button`
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  padding: 8px 16px;
  width: fit-content;
  margin-top: 4px;

  &:hover {
    cursor: pointer;
    background-color: ${palette['color-brand-primary']}
    color: white;
    border: 1px solid ${palette['color-brand-primary']};
  }

  ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return `
          background-color: ${palette['color-brand-primary']};
          color: white;
          border: 1px solid ${palette['color-brand-primary']};
        `;
      case 'secondary':
        return `
          background-color: white;
          color: ${palette['color-grey-500']};
          border: 1px solid ${palette['color-grey-400']};

          &:hover {
            background-color: white;
            color: ${palette['color-brand-primary']}
            border-color: ${palette['color-brand-primary']};
          }
        `;
      case 'inverse':
        return `
          background-color: transparent;
          color: white;
          border: 1px solid white;
        `;
      default:
        return '';
    }
  }}
`;

export const LinkButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0px;
  display: inline-flex;
  text-align: left;
  font-weight: 600;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return `
          color: ${palette['color-brand-primary']};
        `;
      case 'inverse':
        return `
          color: white;
        `;
      default:
        return '';
    }
  }}

  ${({ size }) => {
    switch (size) {
      case 'small':
        return `
          font-size: 12px;
          line-height: 16px;
        `;
      case 'large':
        return `
        font-size: 16px;
        line-height: 22px;
        `;
      default:
        return '';
    }
  }}
`;

export const BannerImage = styled.img`
  position: relative;
  ${({ height, width, position }) =>
    `height: ${height}px !important;
     width: ${width}px !important;
     top: ${position[0]};
     right: ${position[1]};
     bottom: ${position[2]};
     left: ${position[3]}`}
`;
